import React from 'react';
import { connect } from 'react-redux';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { PATHS } from 'constants';
import { setAircraftFilters } from 'actions';
import { SELECT_OPTION_ALL } from 'constants';

import { Col, Row } from 'react-bootstrap';
import LeftNav from 'components/default/LeftNav';
import Ship from './Ship';
import Flight from './Flight';
import LRUFaults from './LRUFaults';
import LRUDetail from './LRUDetail';
import Usage from './Usage';
import Availability from './Availability';
import ConfigurableFeatures from './ConfigurableFeatures';

import styles from './styles.module.css';

const Reports = (props) => {
  const {
    rActiveFlight,
    rAircraftFilters,
    rAircraftMap,
    rAircraftList,
    rFlightList,
    setAircraftFilters,
  } = props;

  const NavMap = {
    Create: [
      {
        display: 'Ship',
        id: 'ship',
      },
      {
        display: 'Flight',
        id: 'flight',
      },
      {
        display: 'LRUs & Faults',
        id: 'lrusFaults',
      },
      {
        display: 'LRU Details',
        id: 'lruDetails',
      },
      {
        display: 'Usage',
        id: 'usage',
      },
      {
        display: 'Compact faults',
        id: 'availability',
      },
      {
        display: 'Config features',
        id: 'configurableFeatures',
      },
    ],
  };

  const defaultPage = 'ship';

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const pathParams = location.pathname?.split('/');
  const selectedReport = pathParams[2] ? pathParams[2] : defaultPage;
  const id = params?.id;

  const onFleetFilterChange = (fleet) => {
    const newFilters = { ...rAircraftFilters, aircraft_type: fleet };
    setAircraftFilters(newFilters);
  };

  const renderMenuItem = () => {
    switch (selectedReport) {
      case 'flight':
        return (
          <Flight
            aircraftMap={rAircraftMap}
            aircraftList={rAircraftList}
            flightList={rFlightList}
            activeFlight={rActiveFlight}
            flightId={id}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'lrusFaults':
        return (
          <LRUFaults
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'lruDetails':
        return (
          <LRUDetail
            aircraftMap={rAircraftMap}
            aircraftList={rAircraftList}
            LruId={id}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'usage':
        return (
          <Usage
            aircraftMap={rAircraftMap}
            aircraftList={rAircraftList}
            activeFlight={rActiveFlight}
            flightId={id}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'availability':
        return (
          <Availability
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'configurableFeatures':
        return (
          <ConfigurableFeatures
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
      case 'ship':
      default:
        return (
          <Ship
            aircraftMap={rAircraftMap}
            aircraftList={rAircraftList}
            aircraftId={id}
            fleetFilter={
              rAircraftFilters?.aircraft_type || SELECT_OPTION_ALL.value
            }
            onFleetFilterChange={(fleet) => onFleetFilterChange(fleet)}
          />
        );
    }
  };

  return (
    <Row className={styles.root} data-cy-id="Reports" noGutters>
      <Col md="auto" className={styles.leftPanel}>
        <LeftNav
          activeMenuItem={!selectedReport ? 'availability' : selectedReport}
          changeActiveMenu={(id) => {
            navigate(`${PATHS.reports}/${id}`);
          }}
          navMap={NavMap}
          primaryHeader="Reports"
          testIdPrefix="Reports"
        />
      </Col>
      <Col className={styles.container}>{renderMenuItem()}</Col>
    </Row>
  );
};

const state = (state) => {
  return {
    rAircraftMap: state.aircraftMap,
    rAircraftList: state.aircraftList,
    rFlightList: state.flightList,
    rActiveFlight: state.activeFlight,
    rAircraftFilters: state.aircraftFilters,
  };
};

const actions = {
  setAircraftFilters,
};

export default connect(state, actions)(Reports);
